import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ManageSalesRepService } from 'src/app/services/manage-sales-rep.service';
import * as _ from "lodash";
import { LoaderService } from 'src/app/shared/services/loader.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ExcelService } from 'src/app/services/excel.service';
import moment from 'moment';
import swal from 'sweetalert2'
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationService } from 'src/app/services/navigation.service';
import { CrudStatusType } from 'src/app/enum/crud-status-type';

@Component({
    selector: 'app-manage-sales-rep',
    templateUrl: './manage-sales-rep.component.html',
    styleUrls: ['./manage-sales-rep.component.scss']
})
export class ManageSalesRepComponent implements OnInit {
    filterValue: string = ''
    data = [];
    dataSource = new MatTableDataSource(this.data);
    displayedColumns: string[] = [
        "salesRepName",
        "salesRepCode",
        "action"
    ];

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild("searchInput", { static: true }) searchInput: ElementRef;
    dataExcel: any = [];
    excelColumns: string[];
    constructor(private ManageSalesRepService: ManageSalesRepService,
        private loaderService: LoaderService,
        private toastr: NotificationService,
        private excelService: ExcelService,
        private navigationService: NavigationService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.getTableData('');
    }

    getTableData(data) {
        if (data) {
            data = { managesalesrepCodeName: data }
        }
        this.ManageSalesRepService.getmanageSalesRepList(data).subscribe((result) => {
            this.data = [];
            this.dataExcel = [];
            this.data = result;
            this.dataExcel = result;
            this.data = _.orderBy(this.data, ["priority"]);
            this.dataSource = new MatTableDataSource(this.data);
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
        });
    }

    applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.filterValue = filterValue;
        // this.dataSource.filter = filterValue.trim().toLowerCase();
        // if (this.dataSource.paginator) {
        //     this.dataSource.paginator.firstPage();
        // }
    }

    clearFilter() {
        const inputElement = document.getElementById('filter-input') as HTMLInputElement;
        if (inputElement) {
            inputElement.value = '';
        }
        this.dataSource.filter = '';
        this.searchInput.nativeElement.value = "";
        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
        this.dataSource.sort.active = '';
        this.dataSource.sort.direction = '';
        this.dataSource.sort.sortChange.emit({ active: '', direction: '' });
        this.getTableData('');
    }

    gotoProductSub(id) {
        if (id === 0) {
            this.navigationService.gotoManageSalesRepAdd(id);
        } else {
            this.ManageSalesRepService.getmanageSalesRepById(id).subscribe((res) => {
                this.ManageSalesRepService.getRestrictEditbySalesRepCode(res.salesRepCode).subscribe((data) => {
                    if (!data) {
                        this.navigationService.gotoManageSalesRepAdd(id);
                    } else {
                        this.toastr.showError("Requested information is in use.");
                    }
                });
            });
        }
    }

    exportAsXLSX(): void {
        this.loaderService.start();
        setTimeout(() => {
            var exportData = this.dataExcel;
            if (!exportData || exportData.length === 0) {
                this.toastr.showInfo("No data available to export");
                this.loaderService.hide();
                return;
            }
            const excelList = [];
            this.excelColumns = [
                "S.No",
                "Sales Rep Name",
                'Sales Rep Code'
            ];
            exportData.forEach((a, index) => {
                excelList.push({
                    sno: ++index,
                    "salesRepName": a.salesRepName,
                    "salesRepCode": a.salesRepCode
                });
            });
            this.excelService.exportAsExcelFile(excelList, "ManageSalesRep_" + moment().format("DDMMYYYYHHmmss") + '.xlsx', this.excelColumns);
            this.loaderService.stop();
        }, 500);
    }

    deleteUser(user) {
        this.ManageSalesRepService.getmanageSalesRepById(user.id).subscribe((res) => {
            this.ManageSalesRepService.getRestrictEditbySalesRepCode(res.salesRepCode).subscribe((data) => {
                if (!data) {
                    const txt = 'You want to delete ' + user?.salesRepName + '?';
                    const Yes = 'Yes';
                    const No = 'No';
                    swal.fire({
                        text: txt,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#7D32DE',
                        cancelButtonColor: '#23C00A',
                        confirmButtonText: Yes,
                        cancelButtonText: No,
                    }).then((result) => {
                        if (result.value) {
                            this.ManageSalesRepService.deletemanageSalesRepById(user.id).subscribe((result) => {
                                if (result.crudStatus == CrudStatusType.ExceptionExists) {
                                    this.toastr.showError(result.additionalInfo);
                                }
                                else if (result.crudStatus == CrudStatusType.DataDeletedSuccessfully) {
                                    this.toastr.showSuccess("Deleted successfully!");
                                }
                                this.clearFilter();
                            });
                        }
                    });
                } else {
                    this.toastr.showError("Requested information is in use.");
                }
            });
        });
    }
}
